export default "__VITE_PUBLIC_ASSET__0235318d__"